import { render, staticRenderFns } from "./gongxu.vue?vue&type=template&id=50933ae2&scoped=true"
import script from "./gongxu.vue?vue&type=script&lang=js"
export * from "./gongxu.vue?vue&type=script&lang=js"
import style0 from "./gongxu.vue?vue&type=style&index=0&id=50933ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50933ae2",
  null
  
)

export default component.exports